export {
  camelKeys as camelcase,
  snakeKeys as snakecase,
} from 'js-convert-case';
